module.exports = __webpack_public_path__ + "img/预留洗衣机.d07e8c59.webp";